/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DdtAspectListResponse } from '../../models/ddt-aspect-list-response';

export interface DdtControllerGetAspects$Params {
}

export function ddtControllerGetAspects(http: HttpClient, rootUrl: string, params?: DdtControllerGetAspects$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DdtAspectListResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, ddtControllerGetAspects.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: DdtAspectListResponse;
      }>;
    })
  );
}

ddtControllerGetAspects.PATH = '/ddt/aspect';
